class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    // Bombas: on /cart the icon stays a plain link — edits made on the cart page don't refresh the drawer,
    // which would open with old lines/totals (and old updates[] behind its checkout button).
    if (/\/cart\/?$/.test(window.location.pathname)) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Upsell add (owner, 27 Oct 2026): the line gets the hidden property _src (upsell_drawer / upsell_pdp) so Scalo counts
   the adds — "_" = hidden in cart and checkout. When the same variant is already in the cart, its quantity goes up
   instead (one line, that add is not tagged). Resolves { ok, body } like a /cart/add.js call with sections. */
window.bbUpsellAdd = function (variantId, quantity, src) {
  var routes = window.routes || {};
  var post = function (url, data) {
    data.sections = 'cart-drawer,cart-icon-bubble';
    data.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok, body: j };
      });
    });
  };
  return fetch((routes.cart_url || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) {
      return r.ok ? r.json() : { items: [] };
    })
    .catch(function () {
      return { items: [] };
    })
    .then(function (cart) {
      var line = (cart.items || []).filter(function (i) {
        return i.variant_id === variantId;
      })[0];
      if (line) return post((routes.cart_change_url || '/cart/change') + '.js', { id: line.key, quantity: line.quantity + quantity });
      return post((routes.cart_add_url || '/cart/add') + '.js', { items: [{ id: variantId, quantity: quantity, properties: { _src: src } }] });
    });
};

/* ══════ CART UPSELL — "Complétez votre commande" (-100 DH sur le 2ème article) ══════
   Self-contained: it never touches the drawer markup. The panel lives in its own
   host element, re-mounted after every drawer re-render (product form, qty change,
   remove, upsell add), and its content comes from sections/cart-upsell.liquid (texts, source item) +
   assets/bombas-reco.js (the products).
   Desktop (>= 990px): side panel to the left of the drawer.
   Mobile: horizontal strip inside the drawer, under the cart lines. */
(function () {
  if (window.__cduInit) return;
  window.__cduInit = true;
  // Bombas i18n: strings from window.bbStrings (layout/theme.liquid, bombas.js.* keys), French fallback.
  function S(k, fb) {
    var b = window.bbStrings;
    return (b && b[k]) || fb;
  }

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var host = document.createElement('div');
  host.className = 'cdu-host';
  host.hidden = true;

  var lastSig = null;
  var timer = null;
  // Last upsell panel (its data-* = source item, texts) and drawer state: each new open re-shuffles the cards
  // (owner, 26 Oct 2026) from the cached pools — no request.
  var lastPanel = null;
  var wasOpen = false;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function place() {
    var d = getDrawer();
    if (!d) return;
    if (DESKTOP.matches) {
      if (host.parentNode !== d) d.appendChild(host);
    } else {
      var items = d.querySelector('cart-drawer-items');
      if (items && host.parentNode !== items) items.appendChild(host);
    }
  }

  function signature() {
    var d = getDrawer();
    if (!d) return '';
    var links = d.querySelectorAll('#CartDrawer .cart-item .cart-item__name');
    return Array.prototype.map
      .call(links, function (a) {
        return a.getAttribute('href');
      })
      .join('|');
  }

  function reshuffle(sig) {
    var panel = lastPanel.cloneNode(true);
    window.BBReco.fillCart(panel).then(function (n) {
      if (sig !== lastSig || !n) return;
      host.innerHTML = panel.outerHTML;
      host.hidden = false;
      place();
    }).catch(function () {});
  }

  function refresh() {
    var d = getDrawer();
    if (!d) return;
    var isOpen = d.classList.contains('active');
    var opened = isOpen && !wasOpen;
    wasOpen = isOpen;
    var sig = signature();
    if (!sig) {
      lastSig = '';
      lastPanel = null;
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    // Lazy: only fetch once the drawer is actually open.
    if (!isOpen) return;
    if (sig === lastSig) {
      if (opened && lastPanel && window.BBReco) reshuffle(sig);
      return;
    }
    lastSig = sig;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-upsell', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (sig !== lastSig) return;
        var html = (data && data['cart-upsell']) || '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var panel = doc.querySelector('.cdu');
        if (!panel) {
          host.hidden = true;
          host.innerHTML = '';
          return;
        }
        // Cards come from assets/bombas-reco.js (audience / stock / size rules); the panel shows once filled.
        lastPanel = panel.cloneNode(true);
        var src = panel.getAttribute('data-reco-src');
        var ready = window.BBReco
          ? Promise.resolve()
          : new Promise(function (resolve) {
              var s = document.createElement('script');
              s.src = src;
              s.onload = s.onerror = resolve;
              document.head.appendChild(s);
            });
        return ready.then(function () {
          if (sig !== lastSig || !window.BBReco) return;
          return window.BBReco.fillCart(panel).then(function (n) {
            if (sig !== lastSig) return;
            if (!n) {
              host.hidden = true;
              host.innerHTML = '';
              return;
            }
            host.innerHTML = panel.outerHTML;
            host.hidden = false;
            place();
          });
        });
      })
      .catch(function (e) {
        lastSig = null;
        console.error('[cart-upsell]', e);
      });
  }

  function schedule() {
    place();
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  host.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cdu-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var card = btn.closest('.cdu-card');
    var err = card && card.querySelector('.cdu-err');
    if (err) err.textContent = '';
    btn.disabled = true;
    if (card) card.classList.add('is-loading');

    var d = getDrawer();

    window
      .bbUpsellAdd(Number(btn.getAttribute('data-cdu-add')), 1, 'upsell_drawer')
      .then(function (res) {
        if (!res.ok || res.body.status) {
          if (err) err.textContent = res.body.description || res.body.message || S('cart_error_retry', 'Erreur, veuillez réessayer.');
          return;
        }
        if (d && typeof d.renderContents === 'function' && res.body.sections) {
          d.renderContents(res.body);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (err) err.textContent = S('cart_error_retry', 'Erreur, veuillez réessayer.');
      })
      .finally(function () {
        btn.disabled = false;
        if (card) card.classList.remove('is-loading');
      });
  });

  function init() {
    var d = getDrawer();
    if (!d) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (!host.contains(mutations[i].target)) {
          schedule();
          return;
        }
      }
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', place);
    else if (DESKTOP.addListener) DESKTOP.addListener(place);

    place();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ══════ QUICK VIEW — "Aperçu rapide" on hover over product images ══════
   Adds a hover button on the images of the cart upsell cards (.cdu-card) and the
   "Vous aimerez aussi" cards (.vr-card). Clicking it opens the product in a modal
   on the same page (gallery, options, quantity, add to cart). The modal content is
   rendered by sections/quick-view.liquid via /products/<handle>?sections=quick-view.
   To add the button to more card types, add a { card, media } pair to TARGETS. */
(function () {
  if (window.__cqvInit) return;
  window.__cqvInit = true;
  // Bombas i18n: strings from window.bbStrings (layout/theme.liquid, bombas.js.* keys), French fallback.
  function S(k, fb) {
    var b = window.bbStrings;
    return (b && b[k]) || fb;
  }

  var TARGETS = [
    { card: '.cdu-card', media: '.cdu-img' },
    { card: '.vr-card', media: '.vr-card-img' },
  ];

  var EYE =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/><circle cx="12" cy="12" r="3"/></svg>';

  var CSS = [
    '.cqv-trigger{position:absolute;left:8px;right:8px;bottom:8px;z-index:2;display:flex;align-items:center;justify-content:center;gap:6px;padding:9px 10px;background:rgba(255,255,255,.96);color:#0a0a0a;border:none;border-radius:2px;font-family:"DM Sans",sans-serif;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;line-height:1;cursor:pointer;opacity:0;transform:translateY(8px);transition:opacity .2s,transform .2s,background .2s,color .2s;box-shadow:0 2px 10px rgba(0,0,0,.12)}',
    '.cqv-trigger svg{width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:1.8;flex:0 0 15px}',
    '.cdu-card:hover .cqv-trigger,.vr-card:hover .cqv-trigger,.cqv-trigger:focus-visible{opacity:1;transform:none}',
    '.cqv-trigger:hover{background:#0a0a0a;color:#fff}',
    '.vr-sz-pill.out{display:none}',
    '.vr-card{display:flex;flex-direction:column}.vr-card-body{flex:1 1 auto;display:flex;flex-direction:column}.vr-card-btn{margin-top:auto}',
    '@media (hover:none){.cqv-trigger{opacity:1;transform:none;left:auto;right:8px;bottom:8px;width:34px;height:34px;padding:0;border-radius:50%}.cqv-trigger span{display:none}}',
    'html.cqv-lock,html.cqv-lock body{overflow:hidden}',
    '.cqv-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .25s}',
    '.cqv-overlay[hidden]{display:none}',
    '.cqv-overlay.is-open{opacity:1}',
    '.cqv-modal{position:relative;background:#fff;width:min(920px,100%);max-height:calc(100vh - 40px);max-height:calc(100dvh - 40px);overflow:hidden;border-radius:4px;transform:translateY(16px);transition:transform .25s;font-family:"DM Sans",sans-serif;color:#0a0a0a}',
    '.cqv-overlay.is-open .cqv-modal{transform:none}',
    '.cqv-close{position:absolute;top:10px;right:12px;z-index:10;width:44px;height:44px;padding:0;border:none;background:#fff;border-radius:50%;font-size:26px;line-height:1;color:#0a0a0a;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center}',
    '.cqv-body{max-height:calc(100vh - 40px);max-height:calc(100dvh - 40px);overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}',
    '.cqv{display:grid;grid-template-columns:1fr 1fr;align-items:start}',
    '.cqv-gallery{position:relative;background:#f5f5f5}',
    '.cqv-track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}',
    '.cqv-track::-webkit-scrollbar{display:none}',
    '.cqv-slide{flex:0 0 100%;scroll-snap-align:start;aspect-ratio:1/1;background:#f5f5f5}',
    '.cqv-slide img{width:100%;height:100%;object-fit:cover;display:block}',
    '.cqv-arrow{position:absolute;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;border:none;background:rgba(255,255,255,.92);color:#0a0a0a;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0 0 3px}',
    '.cqv-arrow--prev{left:10px}.cqv-arrow--next{right:10px}',
    '.cqv-dots{position:absolute;bottom:12px;left:0;right:0;display:flex;justify-content:center;gap:6px;pointer-events:none}',
    '.cqv-dot{width:6px;height:6px;border-radius:50%;background:rgba(0,0,0,.25)}.cqv-dot.is-active{background:#0a0a0a}',
    '.cqv-badge{position:absolute;top:12px;left:12px;background:#d32f2f;color:#fff;font-size:11px;font-weight:700;padding:5px 8px;border-radius:2px}',
    '.cqv-info{padding:34px 28px 28px}',
    '.cqv-title{margin:0 34px 10px 0;font-family:inherit;font-size:18px;font-weight:600;line-height:1.3;color:#0a0a0a}',
    '.cqv-price{font-size:18px;font-weight:700;margin-bottom:12px}',
    '.cqv-price s{font-weight:400;color:#999;font-size:15px;margin-right:8px}',
    '.cqv-offer{display:flex;align-items:center;gap:8px;padding:9px 12px;background:#fdecec;color:#c62828;font-size:13px;line-height:1.35;border-radius:2px;margin-bottom:18px}',
    '.cqv-offer svg{flex:0 0 16px;width:16px;height:16px;stroke:#c62828;fill:none;stroke-width:1.8}',
    '.cqv-opt{margin-bottom:16px}',
    '.cqv-opt-lbl{font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;margin-bottom:8px}',
    '.cqv-opt-lbl span{font-weight:500;text-transform:none;letter-spacing:0;color:#555}',
    '.cqv-values{display:flex;flex-wrap:wrap;gap:8px}',
    '.cqv-val{min-width:46px;height:42px;padding:0 12px;border:1px solid #d4d4d4;background:#fff;border-radius:2px;font-family:inherit;font-size:13px;font-weight:600;color:#0a0a0a;cursor:pointer;transition:border-color .15s}',
    '.cqv-val:hover{border-color:#0a0a0a}',
    '.cqv-val.is-out{color:#aaa;text-decoration:line-through;background:#fafafa}',
    '.cqv-val.is-selected{border:2px solid #0a0a0a;background:#0a0a0a;color:#fff;text-decoration:none}',
    '.cqv-actions{display:flex;gap:10px;margin-top:20px}',
    '.cqv-qty{display:flex;align-items:center;border:1px solid #d4d4d4;border-radius:2px;flex:0 0 auto}',
    '.cqv-qty button{width:38px;height:50px;border:none;background:none;font-size:18px;color:#0a0a0a;cursor:pointer}',
    '.cqv-qty input{width:34px;border:none;text-align:center;font-family:inherit;font-size:14px;-moz-appearance:textfield;background:none}',
    '.cqv-qty input::-webkit-inner-spin-button,.cqv-qty input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}',
    '.cqv-add{flex:1;min-height:52px;background:#000;color:#fff;border:none;border-radius:2px;font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;transition:background .2s}',
    '.cqv-add:hover{background:#1a1a1a}',
    '.cqv-add[disabled]{opacity:.45;cursor:not-allowed}',
    '.cqv-add.is-loading{opacity:.6;pointer-events:none}',
    '.cqv-err{color:#d32f2f;font-size:12px;margin-top:8px}.cqv-err:empty{display:none}',
    '.cqv-link{display:inline-block;margin-top:18px;font-size:12px;color:#0a0a0a;text-decoration:underline;text-underline-offset:3px}',
    '.cqv-loading{min-height:320px;display:flex;align-items:center;justify-content:center}',
    '.cqv-loading span{width:28px;height:28px;border:2px solid #e5e5e5;border-top-color:#0a0a0a;border-radius:50%;animation:cqvspin .7s linear infinite}',
    '@keyframes cqvspin{to{transform:rotate(360deg)}}',
    '@media (max-width:749px){.cqv-overlay{align-items:flex-end;padding:0}.cqv-modal{width:100%;max-height:92vh;max-height:92dvh;border-radius:12px 12px 0 0;transform:translateY(100%)}.cqv-body{max-height:92vh;max-height:92dvh}.cqv{grid-template-columns:1fr}.cqv-info{padding:18px 16px 26px}.cqv-title{font-size:16px}.cqv-price{font-size:16px}}',
  ].join('\n');

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function handleFrom(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var src = a ? a.getAttribute('href') : card.getAttribute('onclick') || '';
    var m = src.match(/\/products\/([^'"?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* ── hover buttons ── */
  function decorate() {
    TARGETS.forEach(function (t) {
      var cards = document.querySelectorAll(t.card);
      Array.prototype.forEach.call(cards, function (card) {
        if (card.querySelector('.cqv-trigger')) return;
        var media = card.querySelector(t.media);
        var handle = handleFrom(card);
        if (!media || !handle) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cqv-trigger';
        btn.setAttribute('aria-label', S('qv_quick_view', 'Aperçu rapide'));
        btn.innerHTML = EYE + '<span>' + esc(S('qv_quick_view', 'Aperçu rapide')) + '</span>';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openQuickView(handle, btn);
        });
        media.appendChild(btn);
      });
    });
  }

  var decoTimer = null;
  new MutationObserver(function () {
    clearTimeout(decoTimer);
    decoTimer = setTimeout(decorate, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* "Vous aimerez aussi": the card's "Ajouter" button opens this same quick view
     instead of the old size sheet. Capture phase + stopPropagation keeps the
     button's inline onclick (vrAddCart) and the card's navigation from firing. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.vr-card .vr-card-btn');
      if (!btn) return;
      var handle = handleFrom(btn.closest('.vr-card'));
      if (!handle) return;
      e.preventDefault();
      e.stopPropagation();
      openQuickView(handle, btn);
    },
    true
  );

  /* ── modal shell ── */
  var overlay, body, lastTrigger, closeTimer;
  // Opened from a "Vous aimerez aussi" card: the add is tagged _src = upsell_pdp (Scalo counts it; hidden in cart / checkout).
  var qvSrc = null;

  /* Phone back button closes the quick view: one history entry is pushed on open
     and popped on close. The entry keeps the current state (facets.js reads
     state.searchParams on popstate, so the grid is not re-rendered). */
  var historyPushed = false;
  window.addEventListener('popstate', function () {
    if (!historyPushed) return;
    historyPushed = false;
    closeQuickView(true);
  });

  function ensureShell() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'cqv-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="cqv-modal" role="dialog" aria-modal="true" aria-label="' + esc(S('qv_quick_view', 'Aperçu rapide')) + '">' +
      '<button type="button" class="cqv-close" aria-label="' + esc(S('qv_close', 'Fermer')) + '">&times;</button>' +
      '<div class="cqv-body"></div></div>';
    document.body.appendChild(overlay);
    body = overlay.querySelector('.cqv-body');
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQuickView();
    });
    overlay.querySelector('.cqv-close').addEventListener('click', closeQuickView);
    // A link inside the quick view ("Voir la fiche produit"…) replaces the quick view's history entry,
    // so Back from the product page returns to the collection in one press.
    overlay.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.cqv-body a[href]');
      if (!a || !historyPushed || a.target === '_blank' || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      historyPushed = false;
      window.location.replace(a.href);
    });
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' && overlay && !overlay.hidden) {
          e.stopPropagation();
          closeQuickView();
        }
      },
      true
    );
  }

  function openQuickView(handle, trigger) {
    ensureShell();
    clearTimeout(closeTimer);
    lastTrigger = trigger;
    qvSrc = trigger && trigger.closest && trigger.closest('[data-bb-reco="vr"]') ? 'upsell_pdp' : null;
    body.innerHTML = '<div class="cqv-loading"><span></span></div>';
    overlay.hidden = false;
    document.documentElement.classList.add('cqv-lock');
    if (!historyPushed) {
      history.pushState(Object.assign({}, history.state, { cqv: true }), '');
      historyPushed = true;
    }
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '?sections=quick-view', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var doc = new DOMParser().parseFromString((data && data['quick-view']) || '', 'text/html');
        var el = doc.querySelector('.cqv');
        if (!el) throw new Error('empty');
        body.innerHTML = el.outerHTML;
        setup(body.querySelector('.cqv'));
        var close = overlay.querySelector('.cqv-close');
        if (close) close.focus({ preventScroll: true });
      })
      .catch(function () {
        // replace: Back from the product page returns to the collection, not to the quick view entry
        window.location.replace(root + 'products/' + encodeURIComponent(handle));
      });
  }

  function closeQuickView(fromPopstate) {
    if (fromPopstate !== true && historyPushed) {
      historyPushed = false;
      history.back();
    }
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('cqv-lock');
    closeTimer = setTimeout(function () {
      overlay.hidden = true;
      body.innerHTML = '';
    }, 250);
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  /* ── modal behaviour ── */
  function setup(root) {
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-cqv-variants]').textContent);
    } catch (e) {}

    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-cqv-option]'));
    var priceEl = root.querySelector('[data-cqv-price]');
    var afterEl = root.querySelector('[data-cqv-after]');
    var addBtn = root.querySelector('[data-cqv-add]');
    var errEl = root.querySelector('[data-cqv-err]');
    var qtyEl = root.querySelector('[data-cqv-qty]');
    var track = root.querySelector('[data-cqv-track]');
    var dots = root.querySelectorAll('.cqv-dot');
    // RTL (/ar/): scrollLeft runs from 0 to negative values, so scroll offsets are mirrored (sign = 1 in LTR).
    var dirSign = track && getComputedStyle(track).direction === 'rtl' ? -1 : 1;

    // Nothing pre-selected when an option has several values: the customer must
    // pick the size themselves (wrong sizes = COD returns).
    // Only in-stock values are shown: drop every value no available variant uses.
    opts.forEach(function (o, i) {
      Array.prototype.forEach.call(o.querySelectorAll('.cqv-val'), function (b) {
        var val = b.getAttribute('data-value');
        var inStock = variants.some(function (v) {
          return v.available && v.options[i] === val;
        });
        if (!inStock) b.parentNode.removeChild(b);
      });
    });

    var selected = opts.map(function (o) {
      var vals = o.querySelectorAll('.cqv-val');
      Array.prototype.forEach.call(vals, function (b) {
        b.classList.remove('is-selected');
      });
      if (vals.length === 1) {
        vals[0].classList.add('is-selected');
        return vals[0].getAttribute('data-value');
      }
      return null;
    });

    function matches(v, skip) {
      return v.options.every(function (o, j) {
        return j === skip || selected[j] == null || o === selected[j];
      });
    }

    function current() {
      if (!opts.length) return variants[0] || null;
      if (selected.some(function (s) { return s == null; })) return null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.every(function (o, j) { return o === selected[j]; })) return variants[i];
      }
      return null;
    }

    function goToMedia(id) {
      if (!track || id == null) return;
      var slides = track.querySelectorAll('.cqv-slide');
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(id)) {
          track.scrollTo({ left: dirSign * i * track.clientWidth, behavior: 'smooth' });
          return;
        }
      }
    }

    function update() {
      opts.forEach(function (o, i) {
        Array.prototype.forEach.call(o.querySelectorAll('.cqv-val'), function (b) {
          var val = b.getAttribute('data-value');
          var ok = variants.some(function (v) {
            return v.available && v.options[i] === val && matches(v, i);
          });
          b.classList.toggle('is-out', !ok);
          b.classList.toggle('is-selected', selected[i] === val);
        });
        var lbl = o.querySelector('[data-cqv-selected]');
        if (lbl) lbl.textContent = selected[i] || '—';
      });

      var v = current();
      if (v) {
        if (priceEl) priceEl.innerHTML = (v.compare ? '<s>' + esc(v.compare) + '</s>' : '') + '<span>' + esc(v.price) + '</span>';
        if (afterEl) afterEl.textContent = v.after;
        goToMedia(v.media);
      }

      if (!addBtn) return;
      var missing = null;
      opts.forEach(function (o, i) {
        if (missing == null && selected[i] == null) missing = o.getAttribute('data-label') || S('qv_an_option', 'une option');
      });
      if (missing) {
        addBtn.disabled = true;
        addBtn.textContent = S('qv_choose', 'Choisissez votre [option]').replace('[option]', function () {
          return missing;
        });
      } else if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = S('qv_unavailable', 'Indisponible');
      } else if (!v.available) {
        addBtn.disabled = true;
        addBtn.textContent = S('qv_sold_out', 'Épuisé');
      } else {
        addBtn.disabled = false;
        addBtn.textContent = S('qv_add_to_cart', 'Ajouter au panier');
        addBtn.setAttribute('data-variant-id', v.id);
      }
    }

    opts.forEach(function (o, i) {
      o.addEventListener('click', function (e) {
        var b = e.target.closest('.cqv-val');
        if (!b) return;
        selected[i] = b.getAttribute('data-value');
        if (errEl) errEl.textContent = '';
        update();
      });
    });

    // gallery
    if (track) {
      var prev = root.querySelector('[data-cqv-prev]');
      var next = root.querySelector('[data-cqv-next]');
      var step = function (dir) {
        track.scrollBy({ left: dirSign * dir * track.clientWidth, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener(
        'scroll',
        function () {
          var idx = Math.round(Math.abs(track.scrollLeft) / Math.max(1, track.clientWidth));
          Array.prototype.forEach.call(dots, function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        },
        { passive: true }
      );
    }

    // quantity
    var minus = root.querySelector('[data-cqv-minus]');
    var plus = root.querySelector('[data-cqv-plus]');
    function qty() {
      return Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    }
    if (minus) minus.addEventListener('click', function () { qtyEl.value = Math.max(1, qty() - 1); });
    if (plus) plus.addEventListener('click', function () { qtyEl.value = qty() + 1; });

    // add to cart
    if (addBtn)
      addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-variant-id');
        if (addBtn.disabled || !id) return;
        addBtn.classList.add('is-loading');
        if (errEl) errEl.textContent = '';
        var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        (qvSrc
          ? window.bbUpsellAdd(Number(id), qty(), qvSrc)
          : fetch(addUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(id), quantity: qty() }],
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname,
              }),
            }).then(function (r) {
              return r.json().then(function (j) {
                return { ok: r.ok, body: j };
              });
            })
        )
          .then(function (res) {
            if (!res.ok || res.body.status) {
              if (errEl) errEl.textContent = res.body.description || res.body.message || S('cart_error_retry', 'Erreur, veuillez réessayer.');
              return;
            }
            closeQuickView();
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function' && res.body.sections) {
              drawer.renderContents(res.body);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () {
            if (errEl) errEl.textContent = S('cart_error_retry', 'Erreur, veuillez réessayer.');
          })
          .finally(function () {
            addBtn.classList.remove('is-loading');
          });
      });

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
  else decorate();
})();

/* ══════ SWIPE LINE — progress bar under horizontal carousels (phone) ══════
   Tells the customer the row can be swiped sideways:
   - cart upsell strip (.cdu-list, mobile layout, native horizontal scroll)
   - "Vous aimerez aussi" (#vr-track, moved with transform by vrScroll)
   Hidden automatically when everything already fits on screen. */
(function () {
  if (window.__cswInit) return;
  window.__cswInit = true;

  var style = document.createElement('style');
  style.textContent = [
    '.csw{position:relative;height:3px;background:#e5e5e5;border-radius:3px;overflow:hidden;margin:2px 18px 16px}',
    '.csw-thumb{position:absolute;top:0;left:0;height:100%;min-width:24px;background:#0a0a0a;border-radius:3px;transition:left .3s ease,width .2s ease}',
    '.vr-section .csw{margin:16px 0 0}',
    '@media (min-width:990px){.csw{display:none!important}}',
  ].join('\n');
  document.head.appendChild(style);

  function makeBar() {
    var bar = document.createElement('div');
    bar.className = 'csw';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="csw-thumb"></div>';
    return bar;
  }

  function paint(bar, total, visible, offset) {
    if (total <= visible + 2) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';
    var thumb = bar.firstChild;
    var w = (visible / total) * 100;
    var maxLeft = 100 - w;
    // Math.abs: in RTL scrollLeft is negative; the thumb then starts from the right edge.
    var left = Math.min(maxLeft, Math.max(0, (Math.abs(offset) / total) * 100));
    thumb.style.width = w + '%';
    if (getComputedStyle(bar).direction === 'rtl') {
      thumb.style.left = 'auto';
      thumb.style.right = left + '%';
    } else {
      thumb.style.left = left + '%';
    }
  }

  // cart upsell strip — native scroll
  function attachScroll(list) {
    if (list.__csw) return;
    list.__csw = true;
    var bar = makeBar();
    list.parentNode.insertBefore(bar, list.nextSibling);
    var update = function () {
      paint(bar, list.scrollWidth, list.clientWidth, list.scrollLeft);
    };
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
    setTimeout(update, 400);
  }

  // "Vous aimerez aussi" — transform-driven track
  function attachTransform(track) {
    if (track.__csw) return;
    var wrap = track.closest('.vr-track-wrap');
    if (!wrap) return;
    track.__csw = true;
    var bar = makeBar();
    wrap.parentNode.insertBefore(bar, wrap.nextSibling);
    var update = function () {
      var m = /translateX\(-?([\d.]+)px\)/.exec(track.style.transform || '');
      paint(bar, track.scrollWidth, wrap.clientWidth, m ? parseFloat(m[1]) : 0);
    };
    new MutationObserver(update).observe(track, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
    setTimeout(update, 400);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.cdu-list'), attachScroll);
    Array.prototype.forEach.call(document.querySelectorAll('.vr-track'), attachTransform);
  }

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
